import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment-timezone';
import * as DateFns from 'date-fns';
import { Link } from 'react-router-dom';

import { CUSTOM_SCOPES, FORMAT_DATE_ROUTE, SCOPE } from '../../../config/constants';
import EventsSelector from './EventsSelector';
import { cleanFetch, formatDateRoute, isCC, isNCAAAllSports, routeToDate } from '../../../helpers';
import WeekSelector from '../../Shared/Filters/WeekSelector';
import TeamsMultiSelector from '../../Shared/Filters/TeamsMultiSelector';
import { useRouter } from '../../../helpers/customHooks';
import { useUserState } from '../../../store/hooks';

import './styles.scss';

const HeaderSchedule = (props) => {

  const { pathname, scope } = useRouter();
  const selectedDate = routeToDate(pathname);
  const user = useUserState();
  const [showFilter, setShowFilter] = useState(-1);
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const [update, setUpdate] = useState(false);

  const nowDate = new Date();

  return (
    <>
      <Row className="schedule-l no-gutters">
        <Col lg={3} xs={3}>
          <h4 className="h-t" style={{ marginLeft: '-14px' }}> Schedule </h4>
        </Col>
        <Col lg={isCC(user) || isMobile  ? 9 : 6} xs={isCC(user) || isMobile  ? 9 : 6}>
          <div
            className="s-tt"
            style={isCC(user) || isMobile ? { right: '0%', left: 'unset', transform: 'translate(-10%, -28%)' } : {}}
          >
            <b>Current Time Zone: </b>
            {`${(new Date()).toString().match(/\((.*)\)/).pop()} (${moment.tz(moment.tz.guess()).format('z')})`}
          </div>
        </Col>
        {(!isCC(user) && !isMobile) && (
          <Col lg={3} xs={3}>
            <Link to={`/schedule/month/${formatDateRoute(selectedDate)}`} onClick={cleanFetch}>
              <div
                className={`button2 ${scope === SCOPE.SCHEDULE.MONTH.PAGE ? 'selected' : ''} label-bold pointer`}
                id={'tab-Month'}
              >
                Month
              </div>
            </Link>
            <Link to={`/schedule/week/${formatDateRoute(selectedDate)}`} onClick={cleanFetch}>
              <div
                className={`button2 ${scope === SCOPE.SCHEDULE.WEEK.PAGE ? 'selected' : ''} label-bold pointer`}
                id={'tab-Week'}
              >
                Week
              </div>
            </Link>
          </Col>
        )}
      </Row>
      <div className="header-row">
        {(isCC(user) || isNCAAAllSports(user)) && (
          <TeamsMultiSelector
            show={showFilter === 1}
            close={() => setShowFilter(-1)}
            open={() => setShowFilter(1)}
            forceScope={CUSTOM_SCOPES.SCHEDULE}
          />
        )}
        <WeekSelector />
        <Link
          to={`/schedule/${scope === SCOPE.SCHEDULE.WEEK.PAGE ? 'week' : 'month'}/${DateFns.format(new Date(nowDate), FORMAT_DATE_ROUTE)}${isMobile? update? '/page?today=1' : '/page?today=0' : ''} `}
          onClick={()=>{
           if(props.clearFetch)cleanFetch();
            setUpdate(!update);}}
        >
          <div className="today-s" id={'button-today'}>Today</div>
        </Link>
        <EventsSelector />
      </div>
    </>
  );
};

export default HeaderSchedule;
